import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import {
  priceCell,
  priceColumn,
} from '#src/components/searchPlayerTable/PriceCell/index.tsx';
import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const PriceSkeleton = styled(Skeleton)`
  width: 60px;
  height: var(--triple-unit);
`;

export const LastCellSkeleton = () => {
  const { statsManager } = useManagePlayerSearchView();

  return (
    <Horizontal gap={0.5} className={priceCell}>
      {statsManager[PlayerSearchViewAttributes.MARKET_VALUE_RARITIES].map(
        rarity => (
          <div key={rarity} className={priceColumn}>
            <PriceSkeleton />
          </div>
        )
      )}
    </Horizontal>
  );
};
